import { idPropType } from "constants/app";
import { bool, func, number, shape, string } from "prop-types";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { paragraphDistanceFor } from "slices/proposalOutline/coverage";
import {
  selectOutlineDocuments,
  selectRequirements,
} from "slices/proposalOutline/selectors";

import CoverageDocumentPane from "../../CoverageDocumentPane";

const TraceDocumentPane = ({
  activeRequirement,
  documentId,
  isDocumentNarrow,
  onToggleNarrow,
}) => {
  const outlineDocuments = useSelector(selectOutlineDocuments);
  const requirements = useSelector(selectRequirements);

  const currentDocument = useMemo(
    () => outlineDocuments.find((d) => d.nextgenDocumentId === documentId),
    [documentId, outlineDocuments]
  );

  const scrollTarget = useMemo(() => {
    if (!activeRequirement) {
      return null;
    }

    return {
      text: activeRequirement.verbatimQuote,
      pageNumber: activeRequirement.pageNumber,
      paragraphDistance: paragraphDistanceFor(activeRequirement, requirements),
    };
  }, [activeRequirement, requirements]);

  return (
    <CoverageDocumentPane
      documentId={documentId}
      documentLabel={currentDocument?.docTypeLabel}
      isDrawer
      isNarrow={isDocumentNarrow}
      onToggleNarrow={onToggleNarrow}
      target={scrollTarget}
    />
  );
};

TraceDocumentPane.propTypes = {
  activeRequirement: shape({
    verbatimQuote: string,
    pageNumber: number,
  }),
  documentId: idPropType,
  isDocumentNarrow: bool,
  onToggleNarrow: func,
};

export default TraceDocumentPane;
